import React from 'react';
import { Box, Heading, Text, VStack, HStack, Image } from '@chakra-ui/react';
import useLogoUrl from '../../hooks/useLogoUrl';
import BrandingBanner from '../BrandingBanner';

interface MethodistSlideProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  showLogo?: boolean;
  isTitleSlide?: boolean;
  captionsText?: string;
  isSpeaking?: boolean;
  showCaptions?: boolean;
  hideHeader?: boolean;
}

export const MethodistSlide: React.FC<MethodistSlideProps> = ({ 
  title, 
  description,
  children, 
  showLogo = true,
  isTitleSlide = false,
  captionsText,
  isSpeaking,
  showCaptions,
  hideHeader
}) => {
  const { logoUrl } = useLogoUrl();
  
  return (
    <Box
      w="100%"
      minH="100vh"
      bg={isTitleSlide ? 'methodist.navy' : 'white'}
      color={isTitleSlide ? 'white' : 'black'}
      p={{ base: 2, sm: 3, md: 4 }}
      overflow="hidden"
      position="relative"
    >
      {/* Content Container */}
      <Box 
        maxW="1400px" 
        w="100%"
        mx="auto"
        h={{ base: "auto", md: "calc(100vh - 80px)" }}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        py={{ base: 2, md: 3 }}
        px={{ base: 2, md: 3 }}
        position="relative"
        overflowY="auto"
        className="slide-content-container"
      >
        {/* Header with branding banner */}
        {!isTitleSlide && showLogo && !hideHeader && (
          <BrandingBanner mb={4} />
        )}
        
        {/* Title */}
        {title && !isTitleSlide && (
          <Heading
            as="h2"
            color="methodist.blue"
            fontSize={{ base: "xl", sm: "2xl" }}
            fontWeight="bold"
            mb={{ base: 3, md: 4 }}
            textAlign="center"
          >
            {title}
          </Heading>
        )}

        {/* Main Content */}
        <Box 
          flex="1" 
          display="flex" 
          flexDirection="column" 
          justifyContent="center"
          w="100%"
        >
          {children}
        </Box>

        {/* Captions */}
        {showCaptions && captionsText && isSpeaking && (
          <Box
            position="absolute"
            bottom="0"
            left="0"
            right="0"
            bg="rgba(0, 0, 0, 0.7)"
            color="white"
            p={2}
            textAlign="center"
            fontSize="md"
          >
            {captionsText}
          </Box>
        )}
      </Box>
    </Box>
  );
};
